module.exports = __webpack_public_path__ + "static/media/product_05.3f4c4c83.jpg";